import React, { useState, useMemo } from "react";
import { Row, Col, Pagination } from "react-bootstrap";
import { normalizeApi } from "shared/api";
// import moment from "moment";
import StartupsProductSlide from "./StartupsProductSlide";
import StartupsProductOverviewLayout from "../StartupsProductOverviewLayout";
import NoAvailableProductsHint from "../NoAvailableProductsHint";

const StartupsProductsOverview = props => {
  const productsPerPage = 20;
  const allProducts = useMemo(
    () => normalizeApi(props.products, "products"),
    [props.products],
  );

  /*
  This was a good idea from Ticket #1493. The problem with this approach is, that it only "works" for startups
  that take part in onboarding 2.0.
  For all other startups it means that their unpublished products cannot be seen anywhere anymore! => #1527
  Hence, we revert this to show all products and will tweak the logik later => #1528
  const publishedProducts = useMemo(
    () =>
      allProducts?.filter(p => moment().isSameOrAfter(p.publishOn, "day")) ??
      [],
    [allProducts],
  );
*/
  // This is the workaround until #1528 is resolved.
  const publishedProducts = allProducts;

  const calculateNumberOfPages = prod => {
    return Math.ceil(prod / productsPerPage);
  };

  const [selectedProducts, setSelectedProducts] = useState(
    publishedProducts?.slice(0, productsPerPage),
  );

  const [activePage, setActivePage] = useState(1);
  const [numberOfPages, setNumberOfPages] = useState(
    calculateNumberOfPages(publishedProducts.length, productsPerPage),
  );

  const selectProducts = page => {
    const startIndex = productsPerPage * (page - 1);
    const paginatedProducts = publishedProducts.slice(
      startIndex,
      startIndex + productsPerPage,
    );

    setActivePage(page);
    setNumberOfPages(
      calculateNumberOfPages(publishedProducts.length, productsPerPage),
    );
    setSelectedProducts(paginatedProducts);
  };

  const setProductWithNewFavorites = productWithNewFavorites => {
    const index = publishedProducts.findIndex(
      product => productWithNewFavorites.id === product.id,
    );

    publishedProducts[index] = productWithNewFavorites;
  };

  const handleSelect = page => {
    selectProducts(page);
    window.scrollTo(0, 0);
  };

  const renderPagination = cols => {
    if (cols.length > 0) {
      return (
        <Row>
          <Col md={12}>
            <Pagination
              className={publishedProducts.length === 0 ? "hidden" : "shown"}
              prev
              next
              first
              last
              ellipsis
              items={numberOfPages}
              activePage={activePage}
              onSelect={handleSelect}
            />
          </Col>
        </Row>
      );
    }
    return undefined;
  };

  if (!selectedProducts || selectedProducts.length === 0) {
    return <NoAvailableProductsHint />;
  }

  const cols = selectedProducts.map(product => {
    return (
      <Col key={product.id} xs={12} md={6} lg={4}>
        <StartupsProductSlide
          url={props.pathToProduct + product.id}
          key={product.id}
          product={product}
          setProductWithNewFavorites={setProductWithNewFavorites}
        />
      </Col>
    );
  });

  return (
    <StartupsProductOverviewLayout>
      <Row>
        <Col md={10} mdPush={1}>
          <Row>{cols}</Row>
        </Col>
      </Row>
      {renderPagination(cols)}
    </StartupsProductOverviewLayout>
  );
};

export default StartupsProductsOverview;
